import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import {
  Box,
  Button,
  Grid,
  IconButton,
  InputBase,
  Modal,
  Paper,
  Typography,
} from "@mui/material";
import React, { useState } from "react";

import ClearIcon from "@mui/icons-material/Clear";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import SearchIcon from "@mui/icons-material/Search";
import SortableTree, {
  toggleExpandedForAll,
} from "@nosferatu500/react-sortable-tree";
import "@nosferatu500/react-sortable-tree/style.css";
import { useMutation } from "react-query";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import { v4 as uuid } from "uuid";
import {
  AddUserOfficePostResponse,
  GetUserOfficePostsResponse,
} from "../../../models/officePosts.model";
import { AddUserOfficePost } from "../../../services/officePosts.service";
import PermissionTable from "./permissionTable";
import TabsEmptyStyle from "./TabsEmptyStyle";

interface Props {
  userOfficePostsList: GetUserOfficePostsResponse[];
  setUpdateGetUserOfficePosts: any;
  treeData: any;
  setTreeData: any;
  setUserOfficePosts: any;
  setUpdateGetUserOfficePostById: any;
}
const deactiveUserStyle = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",

  minWidth: {
    xs: 250,
    sm: 300,
    md: 400,
    lg: 900,
  },

  maxHeight: "90vh",
  minHeight: "30vh",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  // overflow: "auto",
  // overflowX: "hidden",
  paddingRight: "3vh",
  paddingTop: "4vh",
  // direction: "ltr",
  borderRadius: "5px",
  "&::-webkit-scrollbar": {
    width: 7,
  },
  "&::-webkit-scrollbar-track": {
    backgroundColor: "#F9FAFC",
    border: "2px solid #DAE0E4",
  },
  "&::-webkit-scrollbar-thumb": {
    backgroundColor: "#9AAFC4",
  },
};

interface SelectedNodes {
  id: number;
  title: string;
}

const Posts = ({
  userOfficePostsList,
  setUpdateGetUserOfficePosts,
  treeData,
  setTreeData,
  setUserOfficePosts,
  setUpdateGetUserOfficePostById,
}: Props) => {
  const [openAddPostModal, setOpenAddPostModal] = useState(false);
  const [selectedNodesId, setSelectedNodesId] = useState<SelectedNodes[]>([]);
  const [newOfficePosts, setNewOfficePosts] = useState<
    AddUserOfficePostResponse[]
  >();
  const [searchQuery, setSearchQuery] = useState("");

  const history = useHistory<{ permissionUserId: number }>();
  const userId =
    history?.location?.state?.permissionUserId !== undefined
      ? history?.location?.state?.permissionUserId
      : Number(window.localStorage.getItem("PermissionUserId"));
  const { mutate: AddUserOfficePostMutate } = useMutation(AddUserOfficePost, {
    onSuccess: (data: AddUserOfficePostResponse[]) => {
      if (data) {
        setNewOfficePosts(data);
        setOpenAddPostModal(false);
        setUserOfficePosts([...userOfficePostsList, ...data]);
        setSelectedNodesId([]);
        setUpdateGetUserOfficePostById(uuid());
      }
    },
    onError: () => {},
  });

  const handleAddNewUserOfficePost = () => {
    AddUserOfficePostMutate({
      userId: userId,
      officePostIds: selectedNodesId.map((node) => node.id),
    });
  };

  const removeTag = (tagId: number) => {
    setSelectedNodesId(selectedNodesId.filter((node) => node.id !== tagId));
  };

  function expand(expanded: any) {
    setTreeData(
      toggleExpandedForAll({
        treeData,
        expanded,
      })
    );
  }
  function expandAll() {
    expand(true);
  }

  function collapseAll() {
    expand(false);
  }

  const customSearchMethod = (node: any, searchQuery: any) => {
    let result = node.title.props
      ? searchQuery &&
        node.title.props.children[1]
          .toLowerCase()
          .indexOf(searchQuery.toLowerCase()) > -1
      : searchQuery &&
        node.title.toLowerCase().indexOf(searchQuery.toLowerCase()) > -1;

    return result;
  };

  return (
    <>
      <Grid container>
        <Grid item xs={12}>
          <Typography
            onClick={() => {
              treeData?.length > 0
                ? setOpenAddPostModal(true)
                : toast.error("پست سازمانی وجود ندارد");
            }}
            color={"#28A745"}
            fontWeight={"bold"}
            padding={"0.5rem"}
            borderRadius={"5px"}
            sx={{
              cursor: "pointer",
              width: "fit-content",
              "&: hover": { color: "#fff", background: "#28A745" },
            }}
          >
            <AddCircleOutlineIcon sx={{ marginLeft: "7px" }} />
            افزودن پست سازمانی
          </Typography>
        </Grid>
        {userOfficePostsList.length > 0 ? (
          <Grid item xs={12} marginTop={"1.9vh"} sx={{ background: "#F9FCFE" }}>
            <PermissionTable
              userOfficePostsList={userOfficePostsList}
              setUpdateGetUserOfficePosts={setUpdateGetUserOfficePosts}
              userId={userId}
              setUpdateGetUserOfficePostById={setUpdateGetUserOfficePostById}
            />
          </Grid>
        ) : (
          <TabsEmptyStyle text="پست های سازمانی" />
        )}
      </Grid>
      <Modal
        open={openAddPostModal}
        onClose={() => {
          setOpenAddPostModal(false);
          setSelectedNodesId([]);
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={deactiveUserStyle}>
          <Grid
            container
            flexDirection={"column"}
            justifyContent={"center"}
            alignItems={"center"}
            gap={"1rem"}
          >
            <Grid item>
              <Typography
                component={"p"}
                display={"block"}
                textAlign={"center"}
                fontWeight={"bold"}
                // marginY={"3rem"}
                fontSize={"14px"}
                color={"#1D4A87"}
              >
                افزودن پست سازمانی
              </Typography>
            </Grid>
            <Grid width={"100%"} item className="addUserPosts">
              <Box maxWidth={"400px"}>
                <Paper
                  elevation={0}
                  style={{
                    border: "1px solid #DAE0E4",
                    display: "flex",
                  }}
                  square={false}
                >
                  <InputBase
                    sx={{ ml: 1, flex: 1, paddingX: "16px" }}
                    placeholder="جستجو"
                    onChange={(e) => setSearchQuery(e.target.value)}
                    value={searchQuery}
                  />

                  <IconButton
                    type="button"
                    sx={{ color: "#9AAFC4" }}
                    aria-label="search"
                  >
                    <SearchIcon />
                  </IconButton>
                </Paper>
              </Box>
              <div
                style={{
                  paddingRight: "2rem",
                  display: "flex",
                  marginTop: "10px",
                  marginBottom: "10px",
                }}
              >
                <Typography
                  // className="btnForm SuccessDefault"
                  sx={{
                    width: "fit-content",
                    cursor: "pointer",
                    color: "#1D4A87",
                    marginLeft: "5px",
                  }}
                  onClick={() => expandAll()}
                >
                  باز کردن همه
                </Typography>
                |
                <Typography
                  // className="btnForm SuccessDefault"
                  sx={{
                    width: "fit-content",
                    cursor: "pointer",
                    color: "#1D4A87",
                    marginRight: "5px",
                  }}
                  onClick={() => collapseAll()}
                >
                  بستن همه
                </Typography>
              </div>
              <div className="menu-tree">
                <SortableTree
                  canDrag={() => false}
                  treeData={treeData}
                  rowDirection="rtl"
                  searchFocusOffset={0}
                  searchMethod={({ node, searchQuery }) =>
                    customSearchMethod(node, searchQuery)
                  }
                  searchQuery={searchQuery}
                  onChange={(treeData) => {
                    setTreeData(treeData);
                  }}
                  generateNodeProps={(rowInfo) => ({
                    buttons: [
                      <>
                        {!rowInfo.node.isAssigned ? (
                          <div className="sortable-tree-container">
                            {!selectedNodesId.some(
                              (node) => node.id! === rowInfo.node.id
                            ) ? (
                              <button
                                className={
                                  rowInfo.node.isAssigned
                                    ? "sortable-tree-btn"
                                    : "sortable-tree-btn"
                                }
                                onClick={(event: any) => {
                                  if (
                                    !selectedNodesId.some(
                                      (node) => node.id! === rowInfo.node.id
                                    )
                                  ) {
                                    setSelectedNodesId([
                                      ...selectedNodesId,
                                      {
                                        id: rowInfo.node.id,
                                        title: rowInfo.node.title,
                                      },
                                    ]);
                                  }
                                }}
                              >
                                <AddCircleOutlineIcon
                                  sx={{ color: "#607D8B" }}
                                />
                              </button>
                            ) : (
                              <button
                                className={
                                  rowInfo.node.isAssigned
                                    ? "sortable-tree-btn"
                                    : "sortable-tree-btn"
                                }
                                onClick={(event: any) => {
                                  removeTag(rowInfo.node.id);
                                }}
                              >
                                <RemoveCircleOutlineIcon
                                  sx={{ color: "#E6123D" }}
                                />
                              </button>
                            )}
                          </div>
                        ) : (
                          <div className="sortable-tree-container assignedStyle"></div>
                        )}
                      </>,
                    ],
                  })}
                />
              </div>
            </Grid>
            {selectedNodesId.length > 0 && (
              <Box sx={{ borderTop: "1px solid #CCD1D6", width: "100%" }}>
                <Typography
                  sx={{
                    color: "#1D4A87",
                    marginTop: "10px",
                    fontWeight: "bold",
                    marginBottom: "10px",
                  }}
                >
                  پست های اضافه شده
                </Typography>
                <Grid item sx={{ display: "flex", gap: "7px" }}>
                  {selectedNodesId.map((node) => (
                    <Box
                      sx={{
                        background: "#EDEFEF",
                        padding: "5px 10px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                      }}
                    >
                      {node.title}
                      <Typography
                        sx={{ cursor: "pointer" }}
                        onClick={() => removeTag(node.id)}
                      >
                        <ClearIcon
                          sx={{ color: "#34495E", fontSize: "14px" }}
                        />
                      </Typography>
                    </Box>
                  ))}
                </Grid>
              </Box>
            )}
            <Grid item width={"100%"}>
              <Grid
                container
                flexDirection={"row"}
                justifyContent={"left"}
                gap={"1rem"}
              >
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={12}
                  lg={6}
                  maxWidth={"150px !important"}
                >
                  <Button
                    fullWidth
                    variant="contained"
                    disabled={selectedNodesId.length === 0}
                    className={
                      selectedNodesId.length === 0
                        ? "btnForm disabledBtn"
                        : "btnForm SuccessDefault"
                    }
                    onClick={handleAddNewUserOfficePost}
                  >
                    ثبت
                  </Button>
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={12}
                  lg={6}
                  maxWidth={"150px !important"}
                >
                  <Button
                    fullWidth
                    variant="contained"
                    style={{
                      fontSize: "1rem",
                      color: "#fff",
                      height: "40px",
                      background: "#607D8B",
                    }}
                    onClick={() => {
                      setOpenAddPostModal(false);
                      setSelectedNodesId([]);
                    }}
                  >
                    بازگشت
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Box>
      </Modal>
    </>
  );
};

export default Posts;
